import { FunctionComponent } from "react";
import PersistentDrawerLeft from "./SideNavBar";
import { deviceCheck } from "../../Values/utils";

type props = {
  props?: any;
  title:
  | "Organizations"
  | "Contacts"
  | "Users"
  | "Bookings"
  | "Drilldown";
  path: string;
  leadManger: Boolean;
  operationManger: Boolean;
  project?: string;
  task?: string;
  resources?: string;
  callLogs?: string;
  faq?: string;
  api?: string;
  news?: string;
  apiData?: string;
  leadDistributor?: string;
  customButton?: string;
  updatePassword?: string;
  organsationSettting?: string;
  help?:string,
  mmb?:string,
  bannerManagement?:string
};

const AnalyticsSideNav: FunctionComponent<props> = ({
  props,
  title,
  path,
  leadManger,
  operationManger,
  project,
  task,
  resources,
  callLogs,
  faq,
  api,
  news,
  apiData,
  leadDistributor,
  customButton,
  updatePassword,
  organsationSettting,
  help,
  mmb,
  bannerManagement
}) => {
  return (
    <>
      {
        !deviceCheck() && (
          <PersistentDrawerLeft
            props={props}
            title={title}
            path={path}
            leadManger={leadManger}
            operationManger={operationManger}
            project={project}
            task={task}
            resources={resources}
            callLogs={callLogs}
            faq={faq}
            apiData={apiData}
            leadDistributor={leadDistributor}
            api={api}
            news={news}
            customButton={customButton}
            updatePassword={updatePassword}
            organsationSettting={organsationSettting}
            help={help}
            mmb={mmb}
            bannerManagement={bannerManagement}
          />
        )
      }
    </>
  );
};

export default AnalyticsSideNav;
